/************************************************************
 Analysis Namespace
 ************************************************************/

 window.analysis = {
    _action:null,
    _callback:null,
    _row:null,
    // Execute Action
    executeAction:function (action, row, callback) {
        var wfId = parseInt(action.wf_id),
            actionId = parseInt(action.wf_action_id);

        this._action = action;
        this._callback = callback;
        this._row = row;

        // Print requisition
        if(actionId == 23){
            var url = "/reports/download_report_pdf_v2?report_name=external_analysis_requisitions&requisition_id="+(!action.task_id ? '' : action.task_id )+"&patient_id="+row.patient_id+"&ref_episode_id="+row.ref_episode_id;

            Hades.showDocument(url);

            analysis._callback(true, analysis._action, analysis._row);

        }
        // Cancel Requisition
        else if (actionId == 3) {
            analysis.openReason(analysis.cancelReasonModalHandler);
        }
        // Schedule Requisition
        else if (actionId == 6) {
            analysis.openScheduleRequisition(analysis.scheduleRequisitionModalHandler);
        }
        // Delegate Requisition to Insurer
        else if (actionId == 34) {
            analysis.openDelegateRequisitionToInsurer(analysis.delegateRequisitionToInsurer);
        }
        // Associate Documents
        else if (actionId == 55) {
            Hades.loadScreen('/requisition/associate_results', {task_id: action.task_id, origin_type_id: 3});

        }
        // Other actions
        else {
            analysis.executeGenericAction();
        }
    },
    // Execute Generic Action
    executeGenericAction:function () {
        // Show alert for actions without undo
        if(parseInt(analysis._action.wf_action_id) == 18 && !confirm(Hades.markAsReceivedWarning())){
            analysis._callback(true, analysis._action, analysis._row);
            return;
        } else if(parseInt(analysis._action.wf_action_id) == 19 && !confirm(Hades.markAsExecutedWarning())){
            analysis._callback(true, analysis._action, analysis._row);
            return;
        } else if(parseInt(analysis._action.wf_action_id) == 34 && !confirm(Hades.delegateWarning())){
            analysis._callback(true, analysis._action, analysis._row);
            return;
        }

        workflow.executeAction(analysis._action, analysis._callback, analysis._row);
    },
    // Open Reason
    openReason:function (callback) {
        var params = {
            task_id:analysis._action.task_id,
            wf_id:analysis._action.wf_id,
            wf_status_id:analysis._action.to_state_id,
            wf_action_id:analysis._action.wf_action_id};

        $.get('/modal/generic_reason_window', params, null, "html")
            .done(function (data, status, xhr) {
                Hades.checkIfUserIsAuthorized(data, status, xhr);

                $.fancybox({content:data, autoScale:true, autoDimensions:true});

                $('#generic-reason-modal-ct').bind('genericReasonConfirmed', callback);

                Hades.hideLoading();
            })
            .fail(function (xhr, status, error) {
                Hades.showError(error, xhr.responseText, xhr, status, error);
                Hades.hideLoading();
                analysis._callback(false, analysis._action, analysis._row);
            });
    },
    // Cancel Requisition
    cancelReasonModalHandler:function (event, data) {
        $.fancybox.close(true);

        var params = {
            task_id:analysis._row.task_id,
            reason_id:data.reasonId,
            other_reason:data.otherReason,
            cancel_date:data.date,
            cancel_hour:data.hour,
            wf_id:analysis._row.wf_id,
            wf_status_id:analysis._row.wf_status_id,
            wf_action_id:data.actionId};

        $.post('/analysis/cancel_requisition', params, null, 'json')
            .done(function (data, status, xhr) {
                Hades.checkIfUserIsAuthorized(data, status, xhr);

                if (data.success != true) {
                    Hades.showError(Hades.genericErrorMsg(), data.error);
                    Hades.hideLoading();
                    analysis._callback(false, analysis._action, analysis._row);
                } else {
                    analysis._callback(true, analysis._action, analysis._row);
                }
            })
            .fail(function (xhr, status, error) {
                Hades.showError(error, xhr.responseText, xhr, status, error);
                Hades.hideLoading();
                analysis._callback(false, analysis._action, analysis._row);
            });
    },
    // Open Reason
    openScheduleRequisition:function (callback) {
        var params = {
            task_id:analysis._action.task_id,
            wf_id:analysis._action.wf_id,
            wf_status_id:analysis._action.to_state_id,
            wf_action_id:analysis._action.wf_action_id};

        $.get('/analysis/schedule_requisition_modal', params, null, "html")
            .done(function (data, status, xhr) {
                Hades.checkIfUserIsAuthorized(data, status, xhr);

                $.fancybox({content:data, autoScale:true, autoDimensions:true});

                $('#analysis-schedule-requisition-modal-ct').bind('scheduleRequisitionConfirmed', callback);

                Hades.hideLoading();
            })
            .fail(function (xhr, status, error) {
                Hades.showError(error, xhr.responseText, xhr, status, error);
                Hades.hideLoading();
                analysis._callback(false, analysis._action, analysis._row);
            });
    },
    // Open Delegate Requisition to Insurer
    openDelegateRequisitionToInsurer:function (callback) {
        var params = {
            task_id:analysis._action.task_id,
            wf_id:analysis._action.wf_id,
            wf_status_id:analysis._action.to_state_id,
            wf_action_id:analysis._action.wf_action_id};

        $.get('/analysis/delegate_to_insurer_modal', params, null, "html")
            .done(function (data, status, xhr) {
                Hades.checkIfUserIsAuthorized(data, status, xhr);

                $.fancybox({content:data, autoScale:true, autoDimensions:true});

                $('#analysis-delegate-to-insurer-modal-ct').bind('delegateRequisitionToInsurerConfirmed', callback);

                Hades.hideLoading();
            })
            .fail(function (xhr, status, error) {
                Hades.showError(error, xhr.responseText, xhr, status, error);
                Hades.hideLoading();
                analysis._callback(false, analysis._action, analysis._row);
            });
    },
    scheduleRequisitionModalHandler:function (event, data) {
        $.fancybox.close(true);

        Hades.showLoading();

        var params = {
            requisition_id:analysis._row.task_id,
            requisition_date:data.requisition_date,
            requisition_hour:data.requisition_hour,
            analysis_provider_id:data.analysis_provider_id,
            financial_institution_id:data.financial_institution_id,
            is_external:data.is_external};

        $.post('/analysis/schedule_requisition', params, null, 'json')
            .done(function (data, status, xhr) {
                Hades.checkIfUserIsAuthorized(data, status, xhr);

                if (data.success != true) {
                    Hades.showError(Hades.genericErrorMsg(), data.error);
                    Hades.hideLoading();
                    analysis._callback(false, analysis._action, analysis._row);
                } else {
                    if(data.kif_error != null && data.kif_error.length() > 0){
                        bootbox.alert(data.kif_error);
                    }

                    Hades.hideLoading();
                    analysis._callback(true, analysis._action, analysis._row);
                }
            })
            .fail(function (xhr, status, error) {
                Hades.showError(error, xhr.responseText, xhr, status, error);
                Hades.hideLoading();
                analysis._callback(false, analysis._action, analysis._row);
            });
    },
    delegateRequisitionToInsurer:function (event, data) {
        $.fancybox.close(true);

        var params = {
            requisition_id:analysis._row.task_id,
            analysis_provider_id:data.analysis_provider_id,
            financial_institution_id:data.financial_institution_id
        };

        $.post('/analysis/delegate_to_insurer', params, null, 'json')
            .done(function (data, status, xhr) {
                Hades.checkIfUserIsAuthorized(data, status, xhr);

                if (data.success != true) {
                    Hades.showError(Hades.genericErrorMsg(), data.error);
                    Hades.hideLoading();
                    analysis._callback(false, analysis._action, analysis._row);
                } else {
                    Hades.reloadContextualHeader();

                    analysis._callback(true, analysis._action, analysis._row);
                }
            })
            .fail(function (xhr, status, error) {
                Hades.showError(error, xhr.responseText, xhr, status, error);
                Hades.hideLoading();
                analysis._callback(false, analysis._action, analysis._row);
            });
    }
};